const _import = file => () => import("@/views/" + file + ".vue");

export default [
    // 直播列表
    {
        path: "/camera/liveList",
        name: "liveList",
        component: _import("camera/liveList/LiveList")
    },
    // 摄像头绑定
    {
        path: "/camera/cameraManager",
        name: "cameraManager",
        component: _import("camera/cameraManager/CameraManager")
    }
];